import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  GET_ALL_INVOICES,
  GET_ALL_INVOICES_WITH_PAGINATION,
  LIST_CUSTOMERS,
  LIST_INVOICE_BY_ID,
  LIST_ORDERS,
} from '../graphql/invoice.queries';
import {
  CREATE_NEW_INVOICE,
  GENERATE_INVOICE_PDF,
  INVOICE_APPROVE_OR_REJECT,
  MARK_INVOICE_AS_SENT,
  REMOVE_INVOICE_BY_ID,
  UPDATE_INVOICE_BY_ID,
} from '../graphql/invoice.mutations';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  constructor(private http: HttpClient, private apollo: Apollo) {}

  removeInvoiceById(invoiceId: number): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: REMOVE_INVOICE_BY_ID,
      variables: {
        invoiceId,
      },
    });
  }

  getAllInvoices(
    search: string = '',
    limit: number = 10,
    skip: number = 0,
    startDate?: any,
    endDate?: any
  ): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_ALL_INVOICES,
        variables: {
          search,
          limit,
          skip,
          startDate,
          endDate,
        },
        fetchPolicy: 'no-cache',
      })
      .valueChanges.pipe(map((response) => response.data?.invoices));
  }

    getAllInvoicesWithPagination(input: any): Observable<any> {
      return this.apollo
        .use('accounts')
        .watchQuery<any>({
          query: GET_ALL_INVOICES_WITH_PAGINATION,
          variables: {
            input: input,
          },
          fetchPolicy: 'no-cache',
        })
        .valueChanges.pipe(
          map((response) => response.data?.findAllInvoicesWithPagination)
        );
    }





  fetchCustomers(search: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: LIST_CUSTOMERS,
        variables: {
          search,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.customers || []));
  }

  fetchOrders(search: any, customerId: any, isRefund: Boolean): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: LIST_ORDERS,
        variables: {
          search,
          customerId,
          isRefund,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.orders || []));
  }

  createNewInvoice(createInvoiceInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_NEW_INVOICE,
      variables: {
        createInvoiceInput: createInvoiceInput,
      },
    });
  }

  updateInvoiceById(updateInvoiceInput: any, id: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_INVOICE_BY_ID,
      variables: {
        updateInvoiceInput: updateInvoiceInput,
        id: id,
      },
    });
  }

  listInvoiceById(id: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: LIST_INVOICE_BY_ID,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result?.data?.invoice || []));
  }

  approveOrRejectInvoice(invoiceId: any, isApproved: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: INVOICE_APPROVE_OR_REJECT,
      variables: {
        invoiceId: invoiceId,
        isApproved: isApproved,
      },
    });
  }

  markInvoiceAsSent(invoiceId: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: MARK_INVOICE_AS_SENT,
      variables: {
        invoiceId: invoiceId,
      },
    });
  }

  generateInvoicePdf(invoiceId: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: GENERATE_INVOICE_PDF,
      variables: {
        invoiceId: invoiceId,
      },
    });
  }

}
